import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { ModalID } from '../../models/constants';
import { parsePDF417 } from '../../models/drivers-license-parser';

@Component({
  selector: 'app-scan-id',
  templateUrl: './scan-id.component.html',
  styleUrls: ['./scan-id.component.scss'],
  standalone: true,
  imports: [],
})
export class ScanIdComponent {
  barcode: string = '';
  modal_id: number = ModalID.scan_id;
  processing: boolean = false;
  private barcodeBuffer: string = '';
  private barcodeTimeout: any;

  constructor(public sharedService: SharedService) {}
  ngOnInit(): void {
    // this.sharedService.getRecentDriverLicenses();
    document.addEventListener('keypress', this.handleKeyPress);
  }

  ngOnDestroy(): void {
    document.removeEventListener('keypress', this.handleKeyPress);
  }

  handleKeyPress = (event: KeyboardEvent) => {
    clearTimeout(this.barcodeTimeout);
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.processBarcode(this.barcodeBuffer);
      this.barcodeBuffer = '';
    } else {
      this.barcodeBuffer += event.key;
      this.barcodeTimeout = setTimeout(() => {
        this.barcodeBuffer = '';
      }, 50); // Adjust the timeout as needed
    }
  };

  processBarcode(barcode: string): void {
    this.processing = true;
    if (barcode.startsWith('ANSI')) {
      this.sharedService.parsed_license = parsePDF417(barcode);
      if (
        this.sharedService.recent_drivers_license.findIndex(
          (x) =>
            x.licenseNumber === this.sharedService.parsed_license.licenseNumber,
        ) === -1
      ) {
        this.sharedService.saveDriverLicense(this.sharedService.parsed_license);
      }
      this.sharedService.drivers_license_scanned$.next(
        this.sharedService.parsed_license,
      );
      this.closeModal();
    } else {
      if (barcode !== '@' && barcode !== '') {
        this.sharedService.raiseWarningToast(
          `Please scan again. Initial reading:${barcode}`,
        );
      }
    }
  }
  closeModal() {
    setTimeout(() => {
      this.sharedService.closeModal(this.modal_id);
    }, 200);
  }
}
